import React from "react";
import AllSubjectTopics from "../../topics/AllSubjectTopics";


function NcertShortNotePhysTopics() {



  return (
    <>

      <AllSubjectTopics subject="physics" type="ncertshortnote" />

    </>
  );
}

export default NcertShortNotePhysTopics;